<template>
  <b-modal
    :ref="popupRef"
    :title="title"
    :modal-class="modalClass"
    @hidden="onConfirm">
    <div class="content-alert-popup">
      <p
        v-html="content"/>
    </div>
    <template v-slot:modal-footer>
      <div class="alert-popup-footer font-family-notosanscjkkr-medium">
        <b-button
          class="text-gray-1 button-confirm"
          @click = "hide">
          <span class="alert-confirm">{{ confirmText }}</span>
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>

  export default {
    name: "BaseAlertPopup",
    props: {
      popupRef: {
        type: String,
        required: true,
      },
      content: {
        type: String,
        default: ""
      },
      title: {
        type: String,
        default: ""
      },
      confirmButtonColor: {
        type: String,
        default: "#dc3545",
      },
      confirmButtonText: {
        type: String,
        default: "",
      },
      confirmButtonTextColor: {
        type: String,
        default: "#fff",
      },
      confirmButtonBorder: {
        type: String,
        default: "none",
      },
      confirmButtonHeight: {
        type: String,
        default: "32",
      },
      modalClass: {
        type: String,
        default: 'base-alert-popup'
      }
    },
    data() {
      return {
        showModal: false,
        cancelText: "",
        confirmText: "",
      }
    },
    mounted(){
      if (_.isEmpty(this.confirmButtonText)) {
        this.confirmText = this.$t("COMMON.BUTTON.UPPER.OK");
      } else {
        this.confirmText = this.confirmButtonText;
      }
    },
    methods: {
      show() {
        this.$refs[this.popupRef].show();
      },
      hide() {
        this.$refs[this.popupRef].hide();
      },
      onConfirm() {
        this.$emit('onConfirmAction', true)
        this.hide();
      }
    },
  }
</script>
<style lang="scss">
  .content-alert-popup {
    width: 360px;
    height: 72px;
    font-family: NotoSansCJKkr;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.71;
    letter-spacing: normal;
    color: #222222;

  }

  .button-confirm {
    width: 61px;
    height: 32px;
    border-radius: 4px;
    background-color: #0672ff;

  }

  .alert-confirm {
    width: 37px;
    height: 16px;
    font-family: NotoSansCJKkr;
    font-size: 12px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #ffffff;
  }

  .modal-title {
    width: 56px;
    //height: 24px;
    font-family: NotoSansCJKkr;
    font-size: 16px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: #222222;
  }

</style>



// WEBPACK FOOTER //
// src/components/common/popup/BaseAlertPopup.vue